VjsAdmin.Organization = (function () {
    const $table = $('#districts-table');
    const organizationId = $('#districts-table').attr('data-organization-id');

    const init = function () {
        initTable();
    };

    const initTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#districts-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                return `No districts that have < strong > ${$('#search-purchased-for option:selected').text()}${
                    typeof searchTerm !== 'undefined' ? ` < / strong > matching search term < strong > \`${searchTerm}\` < / strong > ` : ''
                }`;
            },
            idField: 'district_id',
            sortName: 'name',
            sortOrder: 'ASC',
            showRefresh: false,
            search: false,
            url: Slim.Router.pathFor('districts.list.json'),
            queryParams(params) {
                const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
                myParams.purchased_for = $('#search-purchased-for option:selected').val();
                myParams.organization_id = organizationId;
                return myParams;
            },
            columns: [
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Purchased?',
                    field: 'purchased',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'ID',
                    field: 'district_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'State',
                    field: 'state_code',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                    field: 'date_modified',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    row.is_active = row.active;

                    row.purchased = '';
                    if (row.platform_1 === '1') {
                        const vjsUrl = Slim.Router.pathFor('platforms.districts.licenses.list', {
                            platform_id: 1,
                            district_joint_guid: row.district_joint_guid,
                        });
                        row.purchased += `<a href="${vjsUrl}" class="btn btn-hollow-blue"><img src="/assets/images/virtualjobshadow.com.icon.png" class="platform-icon" /> Explore </a>&nbsp;`;
                    }
                    if (row.platform_2 === '1') {
                        const jrUrl = Slim.Router.pathFor('platforms.districts.licenses.list', {
                            platform_id: 2,
                            district_joint_guid: row.district_joint_guid,
                        });
                        row.purchased += `<a href="${jrUrl}" class="btn btn-hollow-green"><img src="/assets/images/vjsjunior.com.icon.png" class="platform-icon"/> Junior </a>`;
                    }
                    if (row.platform_4 === '1') {
                        const cpUrl = Slim.Router.pathFor('platforms.districts.licenses.list', {
                            platform_id: 4,
                            district_joint_guid: row.district_joint_guid,
                        });
                        row.purchased += `<a href="${cpUrl}" class="btn btn-hollow-green"><img src="/assets/images/cp-icon.png" class="platform-icon"/> Planner </a>`;
                    }

                    if (VjsAdmin.hasPermission('districts.edit.view')) {
                        const districtEditUrl = Slim.Router.pathFor('districts.edit.view', {
                            district_joint_guid: row.district_joint_guid,
                        });
                        row.actions = `<a href="${districtEditUrl}" class="btn btn-hollow-blue">Edit</a>`;
                    }
                });
                return formattedResult;
            },
        });
    };

    return {
        init,
    };
}());
